// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_dashboard_hints_cases = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of orders per period, broken down by processing status`)
};

const en_us2_dashboard_hints_cases = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of orders per period, broken down by processing status`)
};

const de_de2_dashboard_hints_cases = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl der Vorgänge pro Zeitraum, aufgeschlüsselt nach Verarbeitungsstatus`)
};

const en_dashboard_hints_cases = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of orders per period, broken down by processing status`)
};

const de_dashboard_hints_cases = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl der Vorgänge pro Zeitraum, aufgeschlüsselt nach Verarbeitungsstatus`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const dashboard_hints_cases = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dashboard_hints_cases(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dashboard_hints_cases", locale)
	if (locale === "en-GB") return en_gb2_dashboard_hints_cases(inputs)
	if (locale === "en-US") return en_us2_dashboard_hints_cases(inputs)
	if (locale === "de-DE") return de_de2_dashboard_hints_cases(inputs)
	if (locale === "en") return en_dashboard_hints_cases(inputs)
	return de_dashboard_hints_cases(inputs)
};
export { dashboard_hints_cases as "dashboard.hints.cases" }